import { Col, Row, Spin, Card, message, Typography, Divider } from "antd";
import React, { useLayoutEffect, useState } from "react";
import total from "img/dasboard-weight/total.svg";
import biscuit from "img/dasboard-weight/biscuit_new.png";
import "./chart.scss";
import DutyAndTaxMovementHorizontalChart from "./DutyAndTaxMovementHorizontalChart";

import Page from "_components/Page";
import {
  reportService,
  stockClassificationService,
  dashboardService,
} from "_services";
import NumberInfo from "./NumberInfo";
import { CurrencyFormatter } from "_helpers/formatters";
import DutyMovementLineChart from "./DutyMovementLineChart";
import DutyAgingDoughnetChart from "./DutyAgingDoughnetChart";
import VatMovementLineChart from "./VatMovementLineChart";

const { Title } = Typography;

function TiepHome() {
  const [loadingStockClasses, setLoadingStockClasses] = useState(false);
  const [loadingBomsAging, setBomsAgingLoading] = useState(false);
  const [loadingDutyAging, setDutyAgingLoading] = useState(false);
  const [stockClasses, setStockClasses] = useState([]);
  const [error, setError] = useState(null);
  const [indirectImportLiabilities, setIndirectImportsLiabilities] =
    useState(null);
  const [directImportsLiabilities, setDirectImportsLiabilities] =
    useState(null);
  const [bomsAgingData, setBomsAgingData] = useState(null);
  const [dutyAgingData, setdutyAgingData] = useState(null);
  const [allMaterialsAgingData, setAllMaterialsAgingData] = useState([]);
  const [dutyMovementDataByTime, setDutyMovementDataByTime] = useState(null);
  const [dutyMovementLoading, setDutyMovementLoading] = useState(null);
  const [vatMovementDataByTime, setVatMovementDataByTime] = useState(null);

  useLayoutEffect(() => {
    getDirectImportsLiabilities();
    getIndirectImportsLiabilities();
    getStockClasses();

    getStockIssueDutyVatAging();
    getDutyMovementData();
    getVatMovementData();
  }, []);

  const getVatMovementData = () => {
    setDutyMovementLoading(true);

    dashboardService
      .getVatMovementByTime()
      .then((data) => {
        setDutyMovementLoading(false);
        setVatMovementDataByTime(data.content);
      })
      .catch((error) => {
        message.error(error ?? "error");
        setDutyMovementLoading(false);
        setError(error);
      });
  };

  const getDutyMovementData = () => {
    setDutyMovementLoading(true);

    dashboardService
      .getDutyMovementByTime()
      .then((data) => {
        setDutyMovementLoading(false);
        setDutyMovementDataByTime(data.content);
      })
      .catch((error) => {
        message.error(error ?? "error");
        setDutyMovementLoading(false);
        setError(error);
      });
  };

  const getStockIssueDutyVatAging = () => {
    setDutyAgingLoading(true);

    dashboardService
      .getstockIssuePendingAgingSummary()
      .then((data) => {
        setdutyAgingData(data.content);
        setDutyAgingLoading(false);
      })
      .catch((error) => {
        setError(error);
        setDutyAgingLoading(false);
      });
  };

  const getAllMaterialsAgingData = () => {
    setBomsAgingLoading(true);
    reportService
      .getAgingData()
      .then((data) => {
        setAllMaterialsAgingData(data.content);
        setBomsAgingLoading(false);
      })
      .catch((error) => {
        setError(error);
        setBomsAgingLoading(false);
      });
  };

  const getBomWiseAgingData = () => {
    setBomsAgingLoading(true);
    dashboardService
      .getBomWiseAgingData()
      .then((data) => {
        setBomsAgingData(data.content);
        setBomsAgingLoading(false);
      })
      .catch((error) => {
        setError(error);
        setBomsAgingLoading(false);
      });
  };

  const getStockClasses = () => {
    setLoadingStockClasses(true);
    stockClassificationService
      .getSuggestion()
      .then((data) => {
        setStockClasses(data.content);
      })
      .catch((error) => {
        setLoadingStockClasses(false);
        setError(error);
      });
  };

  const getDirectImportsLiabilities = () => {
    setLoadingStockClasses(true);
    dashboardService
      .getLiabilitySummary("?receiptType=TIEP")
      .then((data) => {
        setDirectImportsLiabilities(data.content);
        setLoadingStockClasses(false);
      })
      .catch((error) => {
        setLoadingStockClasses(false);
        setError(error);
      });
  };

  const getIndirectImportsLiabilities = () => {
    setLoadingStockClasses(true);
    dashboardService
      .getLiabilitySummary("?receiptType=LOCAL")
      .then((data) => {
        setIndirectImportsLiabilities(data.content);
        setLoadingStockClasses(false);
      })
      .catch((error) => {
        setLoadingStockClasses(false);
        setError(error);
      });
  };

  const getNumberFixedDecimalDividedValue = (value, decimalPoints, divisor) => {
    if (value == isNaN || value == null || value == undefined) return 0;

    if (divisor <= 0) return 0;
    return Number(value / divisor).toFixed(decimalPoints);
  };

  return (
    <Page inner className="dashboard" error={error}>
      <Spin tip="Loading..." spinning={loadingStockClasses}>
        <Row gutter={12}>          
          <Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card className="pie-chart-card" bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column' }} title={<span style={{ color: '#f3f4f6', fontSize: '18px', fontWeight: '600', fontFamily: "'Inter', sans-serif" }}>Guarantee Statistics</span>}>
              <div className="stat-grid">
                <div className="stat-item">
                  <div className="stat-header">
                    <span className="stat-label">Total Guarantee</span>
                  </div>
                  <div className="stat-value">
                    {CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.guaranteeValue,
                        2,
                        1
                      )
                    )}
                  </div>
                  <div className="stat-icon" style={{ fontSize: '50px' }}>$</div>
                </div>

                <div className="stat-item">
                  <div className="stat-header">
                    <span className="stat-label">Available Guarantee</span>
                  </div>
                  <div className="stat-value" style={{ color: '#10b981' }}>
                    {CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.availableGuaranteeValue,
                        //9992000,
                        2,
                        1
                      )
                    )}
                  </div>
                  <div className="stat-icon" style={{ fontSize: '50px' }}>✓</div>
                </div>

                <div className="stat-item">
                  <div className="stat-header">
                    <span className="stat-label">TIEP VAT</span>
                  </div>
                  <div className="stat-value" style={{ color: '#f59e0b' }}>
                    {CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.totalReceiptVatAmount,
                        2,
                        1
                      )
                    )}
                  </div>
                  <div className="stat-icon" style={{ fontSize: '50px' }}>%</div>
                </div>

                <div className="stat-item">
                  <div className="stat-header">
                    <span className="stat-label">Utilization</span>
                  </div>
                  <div className="stat-value">
                    {(() => {
                      const total = directImportsLiabilities?.guaranteeValue || 0;
                      const avail = directImportsLiabilities?.availableGuaranteeValue || 0;
                      const used = total - avail;
                      if (!total) return <small>N/A</small>;
                      return ((used / total) * 100).toFixed(1) + "%";
                    })()}
                  </div>
                  <div className="stat-icon" style={{ fontSize: '50px' }}>📈</div>
                </div>
              </div>
            </Card>
          </Col>
          <Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card className="pie-chart-card" bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              {directImportsLiabilities ? (
                <DutyAndTaxMovementHorizontalChart
                  title="TIEP-1"
                  liabilities={directImportsLiabilities}
                />
              ) : (
                <h2>Server Maybe Busy!</h2>
              )}
            </Card>
          </Col>
        </Row>
        <Spin tip="Loading..." spinning={loadingStockClasses}>
          <Row gutter={24} style={{ padding: '0 10px' }}>
            <Col span={12}>
              <Row gutter={24}>
                <Col span={24}>
                  <Divider>
                    <Title level={3}>IMPORTS</Title>
                  </Divider>
                </Col>

                <Col span={12}>
                  <NumberInfo
                    title="Direct Imports"
                    iconImage={biscuit}

                    // Stat 1
                    categoryTitle="Total DUTY Liability(M)"
                    totalItems={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.netLiability,
                        2,
                        1
                      )
                    )}

                    // Stat 2
                    categoryTitle1="Pending Cancellation Credit(M)"
                    totalQuantity={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.totalPendingCancellationLiability,
                        2,
                        1
                      )
                    )}
                  />
                </Col>

                <Col span={12}>
                  <NumberInfo
                    title="Indirect Imports"
                    iconImage={biscuit}

                    // Stat 1
                    categoryTitle="Total DUTY Liability(M)"
                    totalItems={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        indirectImportLiabilities?.netLiability,
                        2,
                        1
                      )
                    )}

                    // Stat 2
                    categoryTitle1="Pending Cancellation Credit(M)"
                    totalQuantity={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        indirectImportLiabilities?.totalPendingCancellationLiability,
                        2,
                        1
                      )
                    )}
                  />
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={24}>
                <Col span={24}>
                  <Divider>
                    <Title level={3}>EXPORTS</Title>
                  </Divider>
                </Col>

                <Col span={12}>
                  <NumberInfo
                    title="Direct Exports"
                    iconImage={biscuit}

                    // Stat 1
                    categoryTitle="Total DUTY Liability(M)"
                    totalItems={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.totalExportLiability,
                        2,
                        1
                      )
                    )}

                    // Stat 2
                    categoryTitle1="Pending Cancellation Credit(M)"
                    totalQuantity={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        directImportsLiabilities?.totalExportPendingCancellationLiability,
                        2,
                        1
                      )
                    )}
                  />
                </Col>
                <Col span={12}>
                  <NumberInfo
                    title="Indirect Exports"
                    iconImage={biscuit}

                    // Stat 1
                    categoryTitle="Total DUTY Liability(M)"
                    totalItems={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        indirectImportLiabilities?.totalExportLiability,
                        2,
                        1
                      )
                    )}

                    // Stat 2
                    categoryTitle1="Pending Cancellation Credit(M)"
                    totalQuantity={CurrencyFormatter(
                      getNumberFixedDecimalDividedValue(
                        indirectImportLiabilities?.totalExportPendingCancellationLiability,
                        2,
                        1
                      )
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Divider>
            <Title level={2}>MOVEMENTS</Title>
          </Divider>
          <Row gutter={24} style={{ padding: '0 10px' }}>
            <Col span={12}>
              <div className="modern-chart-container">
                <DutyMovementLineChart data={dutyMovementDataByTime} />
              </div>
            </Col>
            {/* <Col span={8}>
              <div className="modern-chart-container">
                <DutyAgingDoughnetChart data={dutyAgingData} />
              </div>
            </Col> */}
            <Col span={12}>
              <div className="modern-chart-container">
                <VatMovementLineChart data={vatMovementDataByTime} />
              </div>
            </Col>
          </Row>

          {/* <Row gutter={12}>
          {stockClasses?.map((classification) =>
            //Stop showing the packing material classification
            classification?.name != "PACKING MATERIAL" ? (
              <Col span={12} className="col-center">
                <StockMovementLineChart
                  stockClass={classification}
                ></StockMovementLineChart>
              </Col>
            ) : (
              ""
            )
          )}
        </Row> */}
        </Spin>
      </Spin>
    </Page>
  );
}

export default TiepHome;
